export default __webpack_public_path__ + "static/media/cider-long.3d6ab04f.svg";